<template>
  <button
    :class="data.class"
    @click="event"
  >
    {{ data.text }}
  </button>
</template>

<script>
export default {
    name: "Button",
    props: {
        data: {
            required: true,
            type: Object
        }
    },
    methods: {
        event() {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
button {
    color: white;
    font-weight: 700;
    width: 100%;
    max-width: 288px;
    border: none;
    border-radius: 4px;
    font-size: 1.25rem;
    cursor: pointer;
}

.aprovado {
    background: #2cB55B;
}

.em-analise {
    background: #565656;
}

.reprovado {
    background: #E20000;
}

button.modal {
    background: #1D43FF;
}

.modal-cancelar {
    background: #d3d3d3;
    color: #8b8b8b;
}
</style>